export default __webpack_public_path__ + "static/media/ic_Admin.4817790f.svg";